import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Homepage.css';
import ActionButton from './ActionButton.jsx';
import AnnouncementCard from './AnnouncementCard.jsx';
import { FaBullhorn, FaCalendarAlt, FaBook, FaUsers } from 'react-icons/fa';
import IGSessionManager from "./IGSessionManager.jsx";

const actions = [
  { icon: <FaBullhorn />, title: 'Send Message', subtitle: 'Broadcast to Captains', color: '#D4E6F1', path: '/push-message' },
  { icon: <FaCalendarAlt />, title: 'Add Events', subtitle: 'Add events to calendar', color: '#FCF3CF', path: '/addevents' }, 
  { icon: <FaBook />, title: 'Handle Bookings', subtitle: 'Manage Bookings', color: '#E8DAEF', path: '/handlebookings' }, 
  { icon: <FaUsers />, title: 'View Members', subtitle: 'View all members', color: '#FADBD8', path: '/view-members' }, 
];

export default function Homepage() {

  const navigate = useNavigate();

  const handleActionClick = (path) => {
    // Check if a path is provided before navigating
    if (path) {
      navigate(path);
    } else {
      console.log("No path defined for this action.");
    }
  };

  return (
    <div className="app-container">
      <main className="homepage-content">
        <div className="announcement-section">
          <AnnouncementCard />
        </div>

        <div className="actions-section">
          <div className="actions-grid">
            {actions.map((action) => (
              // 5. Pass the click handler to each ActionButton.
              //    Using action.title as the key is better than the index.
              <ActionButton
                key={action.title}
                {...action}
                onClick={() => handleActionClick(action.path)}
              />
            ))}
          </div>
          
          <div className="ig-session-section" style={{ marginTop: '2rem' }}>
              <IGSessionManager />
          </div>
        </div>
      </main>
    </div>
  );
}
